import { ProgressCircleComponent } from "@/components/progress/progress-circle";
import { AppColors } from "@/styles/colors";
import { Badge, Flex, Text, WrapItem, Stack } from "@chakra-ui/react";
import { Info } from "lucide-react";

interface Props {
  title: string;
  legend: string;
  similarItems: string[];
  loadingSimilarElements?: boolean;
}

export const SimilarRelationFieldsAlert = ({
  legend,
  similarItems,
  title,
  loadingSimilarElements,
}: Props) => {
  return (
    <>
      <Flex
        flexDir="column"
        data-testid="similar-fields-alert"
        bgColor={AppColors.YELLOW_ALT}
        paddingY="20px"
        paddingX="30px"
        borderRadius="6px"
        gap="16px"
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            maxWidth: "400px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            maxWidth: "450px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            maxWidth: "500px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            maxWidth: "500px",
          },
          "@media (max-width: 1920px)": {
            maxWidth: "500px",
          },
        }}
      >
        {/* Icono + título + leyenda */}
        <Flex align="start" gap="12px">
          <Info
            size={24}
            color={AppColors.ORANGE_TEXT_1}
            style={{ marginTop: "2px" }}
          />
          <Stack spaceY="4px">
            <Text
              fontWeight={500}
              fontSize="16px"
              color={AppColors.ORANGE_TEXT_1}
            >
              {title}
            </Text>
            <Text fontSize="sm" color={AppColors.ORANGE_TEXT_1}>
              {legend}
            </Text>
          </Stack>
        </Flex>
      </Flex>
      {/* Texto de similitudes */}
      <Flex alignItems="center" gap="16px">
        <Text fontWeight="semibold">Similitudes con: </Text>
        {loadingSimilarElements && <ProgressCircleComponent size="xs" />}
      </Flex>

      {/* Badges distribuidos */}
      <Flex
        flexWrap="wrap"
        gap="8px"
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            maxHeight: "150px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            maxHeight: "230px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            maxHeight: "310px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            maxHeight: "420px",
          },
        }}
        overflowY="auto"
      >
        {!loadingSimilarElements &&
          similarItems?.map((item) => (
            <WrapItem key={item}>
              <Badge
                variant="subtle"
                colorScheme="yellow"
                paddingX="12px"
                paddingY="6px"
                borderRadius="full"
              >
                <Text fontSize="sm">{item}</Text>
              </Badge>
            </WrapItem>
          ))}
      </Flex>
    </>
  );
};
